import { z } from 'zod'
import { requiredText } from '../../../lib/forms/rules'

/**
 * Notlarım liste adı formu (113). Ad **zorunludur** ve en çok **100 karakter**tir.
 *
 * <p>Sınır kullanıcı kararıdır (24.09.2026): ad telefonda kart başlığı olarak gösteriliyor ve ~360px
 * genişlikte satır başına kabaca 28-32 karakter sığıyor. Aynı sınır sunucuda da zorlanır — buradaki
 * doğrulama kullanıcıya erken ve alan bazlı geri bildirim vermek içindir, kapı değildir.
 */
export const todoListFormSchema = z.object({
  name: requiredText(100),
})

export type TodoListFormValues = z.infer<typeof todoListFormSchema>
